import React, {useRef, useState, Fragment} from "react";
import DateFormat from "./dateFormat";
import PopUp from "../../base/popup";
import ResetPopup from "./resetPopup";
import ResetConfirmationPopup from "./resetConfirmationPopup";

export default function StatementResults(props) {



    const [limit, setLimit] = useState(10);
    const [expanded, setExpanded] = useState(false);
    const resetPopupRef = useRef(null);
    const confirmationResetPopupRef = useRef(null);

    const toggleResults = () => {
      if (expanded) {
          setLimit(10)
      } else {
          setLimit(props.results.length)
      }
      setExpanded(!expanded);
    };

    const afterResetTest = () => {
        resetPopupRef.current.open()
    };

    const reset = () => {
        props.reset(props.testId, afterResetTest);
        confirmationResetPopupRef.current.close();

    };
    if(props.temp || !props.isAvailable) {
        return (
            <div className={props.parentClass}>
                <div className="user__box ">
                    <div className="grid-x user__test">
                        <div className="small-9 cell"><h3 className="user__test-title">{props.name}</h3></div>
                        <div className="small-3 cell flex-end"><span className="small-icon minus-icon--red"/></div>
                    </div>
                    <div className="user__incomplete">
                        <h3>{props.isAvailable ? 'Test incomplete' : 'Access required'}</h3>
                    </div>
                </div>
            </div>
        )
    }


    return(
        <div className={props.parentClass}>
            <div className={`user__box ${expanded ? 'user__box--equal' : ''}`}>
                <div className="grid-x user__test">
                    <div className="small-9 cell"><h3 className="user__test-title">{props.name}</h3></div>
                    <div className="small-3 cell flex-end"><span className={`small-icon ${props.finished ? 'tick-icon' : 'minus-icon--red'}`}/></div>
                </div>
                <div className="user__box__all-res">
                {props.results.slice(0,limit).map((result) => {
                    return <p className={`user__box__results ${!props.finished ? 'user__box__results--disable' : ''}`} key={result.group_id}><span className="user__box__value">{result.score}%</span><span
                        className="user__box__desc">{result.group_name}</span></p>
                })}
                </div>
                <div className="small-12 cell mar-top-20"><h5 className="white-link" onClick={toggleResults}>{expanded ? 'Close' : 'View all'}</h5></div>
                {!props.finished ? <div style={{height: "40px"}}/> :
                    <Fragment>
                    <div className="grid-x align-middle">
                        <div className="small-12 cell"><p className="user__box__date">Date taken:
                            {DateFormat.format(props.finished_at)}</p></div>
                    </div>
                    <div className="grid-x align-middle mar-top-10">
                        <div className="small-6 cell shrink flex-start">
                            <a className={'button button--green'} href={`/group/tests/${props.testCode}/download/${props.userId}`} target={'_blank'}><span className="button__hovered"/>Report</a>
                        </div>
                        <div className="small-6 cell shrink flex-end">
                            <button onClick={() => {confirmationResetPopupRef.current.open()}} className="button button--white"><span className="button__hovered"/>Reset
                                test
                            </button>
                        </div>
                    </div>
                    </Fragment>
                }
                <PopUp ref={resetPopupRef}>
                    <ResetPopup retakes={props.retakes} name={props.name}/>
                </PopUp>
                <PopUp ref={confirmationResetPopupRef}>
                    <ResetConfirmationPopup onCancel={() => {confirmationResetPopupRef.current.close()}} onConfirm={reset}/>
                </PopUp>
            </div>

        </div>
    )

}